import { useEffect, useState } from "react";
import "./ExcluirOrigemCarregamentoTrilhosReempregoModal.css";

export default function ExcluirOrigemCarregamentoTrilhosReempregoModal({ open, titulo, onClose, onConfirmar }) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (!open) return;
    setBusy(false);
    setErr("");
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  if (!open) return null;

  async function handleConfirmar() {
    if (busy) return;
    setBusy(true);
    setErr("");
    try {
      await onConfirmar?.();
      onClose?.();
    } catch (e) {
      setErr(e?.response?.data?.error || e?.message || "Falha ao excluir.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="ocrex-bg" onClick={onClose}>
      <div className="ocrex-box" role="dialog" aria-modal="true" aria-label="Excluir origem reemprego" onClick={(e) => e.stopPropagation()}>
        <header className="ocrex-head">
          <h3 className="ocrex-title">Excluir</h3>
          <button className="ocrex-x" onClick={onClose} type="button" aria-label="Fechar" disabled={busy}>x</button>
        </header>
        <div className="ocrex-body">
          Tem certeza que deseja <strong>excluir</strong> "{titulo || "esta origem"}"?
          <div className="ocrex-warn">Esta acao nao pode ser desfeita.</div>
          {err ? <div className="ocrex-err">{err}</div> : null}
        </div>
        <footer className="ocrex-foot">
          <button className="ocrex-btn" type="button" onClick={onClose} disabled={busy}>Cancelar</button>
          <button className="ocrex-btn ocrex-btn-danger" type="button" onClick={handleConfirmar} disabled={busy}>
            {busy ? "Excluindo..." : "Excluir"}
          </button>
        </footer>
      </div>
    </div>
  );
}


